<template>
  <section v-if="!loading">
    <div class="d-flex flex-column">
      <section-header :title="$t('apps.accounting.message.journalautomatedaccountsmapping')"/>
      <div
        class="d-flex flex-column"
        style="gap: 10px"
      >
        <div class="d-flex flex-column">
          <div class="mb-1">
            {{ $t('apps.accounting.label.accountingtransactions') }}:
          </div>
          <b-button-group>
            <b-button
              :pressed="selectedDocumentTypes.includes(KEY_NAME.POS)"
              @click="handleToggleDocumentType(KEY_NAME.POS)"
            >
              {{ this.$t('apps.accounting.journal_mapping.pos_headertitle') }}
            </b-button>
            <b-button
              :pressed="selectedDocumentTypes.includes(KEY_NAME.INVOICE)"
              @click="handleToggleDocumentType(KEY_NAME.INVOICE)"
            >
              {{ this.$t('apps.accounting.journal_mapping.invoice_headertitle') }}
            </b-button>
            <b-button
              :pressed="selectedDocumentTypes.includes(KEY_NAME.PURCHASE)"
              @click="handleToggleDocumentType(KEY_NAME.PURCHASE)"
            >
              {{ this.$t('apps.accounting.journal_mapping.purchase_headertitle') }}
            </b-button>
            <b-button
              :pressed="selectedDocumentTypes.includes(KEY_NAME.EXPENSE)"
              @click="handleToggleDocumentType(KEY_NAME.EXPENSE)"
            >
              {{ this.$t('apps.accounting.journal_mapping.expense_headertitle') }}
            </b-button>
          </b-button-group>
        </div>
        <template v-if="isRender">
          <AccountMapping
            v-for="(data, index) in accountingMappingList"
            :id="data.keyName"
            :key="index"
            :keyName="data.keyName"
            :headerTitle="data.headerTitle"
            :headerSubTitle="data.headerSubTitle"
            :itemTitle="data.itemTitle"
            :links="data.links"
            :items="data.items"
            :disabledDebit="data.disabledDebit"
            :disabledCredit="data.disabledCredit"
            :accountMapping="accountMapping"
            @onChange="handleItemsChange"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { cloneDeep } from 'lodash'
import AccountMapping from './AccountMapping.vue'
import { mapGetters } from 'vuex'
import { getMasterDataText } from '@/helpers'

const KEY_NAME = {
  POS: 'pos',
  INVOICE: 'invoice',
  PURCHASE: 'purchase',
  EXPENSE: 'expense',
  PAYMENT_ENTRY: 'payment_entry',
  TAX_SALE: 'tax_sale',
  TAX_PURCHASE: 'tax_purchase',
  WHT_SALE: 'wht_sale',
  WHT_PURCHASE: 'wht_purchase',
  SERVICE_CHARGE: 'service_charge',
  FEE: 'fee',
  COST_OF_SALE: 'cost_of_sale',
}

export default {
  components: {
    AccountMapping,
  },

  props: {
    branches: {
      type: Array,
    },
  },

  data() {
    return {
      KEY_NAME,
      loading: true,
      isRender: true,
      selectedDocumentTypes: [
        KEY_NAME.POS,
      ],
      accountMapping: {
        [KEY_NAME.POS]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.pos_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.pos_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.pos_itemtitle'),
          links: [
            {
              ref: KEY_NAME.TAX_SALE,
              text: this.$t('apps.accounting.journal_mapping.taxsale_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.SERVICE_CHARGE,
              text: this.$t('apps.accounting.journal_mapping.servicecharge_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.FEE,
              text: this.$t('apps.accounting.journal_mapping.fee_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.COST_OF_SALE,
              text: this.$t('apps.accounting.journal_mapping.categorysale_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: false,
        },
        [KEY_NAME.INVOICE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.invoice_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.invoice_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.invoice_itemtitle'),
          links: [
            {
              ref: KEY_NAME.TAX_SALE,
              text: this.$t('apps.accounting.journal_mapping.taxsale_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.WHT_SALE,
              text: this.$t('apps.accounting.journal_mapping.whtsale_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.PAYMENT_ENTRY,
              text: this.$t('apps.accounting.journal_mapping.paymententry_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.COST_OF_SALE,
              text: this.$t('apps.accounting.journal_mapping.categorysale_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: false,
        },
        [KEY_NAME.PURCHASE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.purchase_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.purchase_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.purchase_itemtitle'),
          links: [
            {
              ref: KEY_NAME.TAX_PURCHASE,
              text: this.$t('apps.accounting.journal_mapping.taxpurchase_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.WHT_PURCHASE,
              text: this.$t('apps.accounting.journal_mapping.whtpurchase_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.PAYMENT_ENTRY,
              text: this.$t('apps.accounting.journal_mapping.paymententry_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: false,
        },
        [KEY_NAME.EXPENSE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.expense_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.expense_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.expense_itemtitle'),
          links: [
            {
              ref: KEY_NAME.TAX_PURCHASE,
              text: this.$t('apps.accounting.journal_mapping.taxpurchase_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.WHT_PURCHASE,
              text: this.$t('apps.accounting.journal_mapping.whtpurchase_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.PAYMENT_ENTRY,
              text: this.$t('apps.accounting.journal_mapping.paymententry_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: false,
        },
        [KEY_NAME.TAX_SALE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.taxsale_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.taxsale_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.taxsale_itemtitle'),
          links: [
            {
              ref: KEY_NAME.POS,
              text: this.$t('apps.accounting.journal_mapping.pos_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.INVOICE,
              text: this.$t('apps.accounting.journal_mapping.invoice_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: true,
          disabledCredit: false,
        },
        [KEY_NAME.TAX_PURCHASE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.taxpurchase_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.taxpurchase_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.taxpurchase_itemtitle'),
          links: [
            {
              ref: KEY_NAME.PURCHASE,
              text: this.$t('apps.accounting.journal_mapping.purchase_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.EXPENSE,
              text: this.$t('apps.accounting.journal_mapping.expense_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: true,
        },
        [KEY_NAME.WHT_SALE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.whtsale_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.whtsale_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.whtsale_itemtitle'),
          links: [
            {
              ref: KEY_NAME.INVOICE,
              text: this.$t('apps.accounting.journal_mapping.invoice_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: true,
        },
        [KEY_NAME.WHT_PURCHASE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.whtpurchase_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.whtpurchase_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.whtpurchase_itemtitle'),
          links: [
            {
              ref: KEY_NAME.PURCHASE,
              text: this.$t('apps.accounting.journal_mapping.purchase_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.EXPENSE,
              text: this.$t('apps.accounting.journal_mapping.expense_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: true,
          disabledCredit: false,
        },
        [KEY_NAME.SERVICE_CHARGE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.servicecharge_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.servicecharge_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.servicecharge_itemtitle'),
          links: [
            {
              ref: KEY_NAME.POS,
              text: this.$t('apps.accounting.journal_mapping.pos_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: true,
          disabledCredit: false,
        },
        [KEY_NAME.FEE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.fee_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.fee_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.fee_itemtitle'),
          links: [
            {
              ref: KEY_NAME.POS,
              text: this.$t('apps.accounting.journal_mapping.pos_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: false,
        },
        [KEY_NAME.PAYMENT_ENTRY]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.paymententry_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.paymententry_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.paymententry_itemtitle'),
          links: [
            {
              ref: KEY_NAME.INVOICE,
              text: this.$t('apps.accounting.journal_mapping.invoice_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.PURCHASE,
              text: this.$t('apps.accounting.journal_mapping.purchase_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.EXPENSE,
              text: this.$t('apps.accounting.journal_mapping.expense_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: false,
        },
        [KEY_NAME.COST_OF_SALE]: {
          headerTitle: this.$t('apps.accounting.journal_mapping.categorysale_headertitle'),
          headerSubTitle: this.$t('apps.accounting.journal_mapping.categorysale_headersubtitle'),
          itemTitle: this.$t('apps.accounting.journal_mapping.categorysale_itemtitle'),
          links: [
            {
              ref: KEY_NAME.POS,
              text: this.$t('apps.accounting.journal_mapping.pos_headertitle'),
              onClick: this.handleClickLink,
            },
            {
              ref: KEY_NAME.INVOICE,
              text: this.$t('apps.accounting.journal_mapping.invoice_headertitle'),
              onClick: this.handleClickLink,
            },
          ],
          items: [],
          disabledDebit: false,
          disabledCredit: false,
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      saleSetting: 'getSaleSetting',
      purchaseSetting: 'getPurchaseSetting',
      expenseSetting: 'getExpenseSetting',
      accountSetting: 'getAccountSetting',
      taxes: 'getTaxes',
      categories: 'getCategories',
    }),
    accountingMappingList() {
      return Object.keys(this.accountMapping)
        .map((keyName) => {
          return {
            keyName: keyName,
            ...this.accountMapping[keyName],
            links: this.accountMapping[keyName].links.map((link) => {
              return {
                refId: keyName,
                ...link,
              }
            }),
          }
        })
        .filter((data) => data.items.length > 0)
        .filter((data) => {
          if (this.selectedDocumentTypes.includes(data.keyName)) {
            return true
          }
          return data.links.reduce((acc, cur) => {
            if (this.selectedDocumentTypes.includes(cur.ref)) {
              acc = true
            }
            return acc
          }, false)
        })
        .reduce((acc, cur, idx, arr) => {
          const keyNames = arr.map((item) => item.keyName)
          acc.push({
            ...cur,
            items: (() => {
              if (cur.keyName === KEY_NAME.PAYMENT_ENTRY) {
                return Object.keys(this.accountSetting.payment_entry.journal)
                  .map((key) => {
                    const docName = key
                    const patt = {
                      invoice: this.$t('documents.in'),
                      purchase: this.$t('documents.po'),
                      expense: this.$t('documents.ex'),
                      payslip: this.$t('documents.prl'),
                    }
                    const debit_account_disabled = [KEY_NAME.PURCHASE, KEY_NAME.EXPENSE].includes(key)
                    const credit_account_disabled = [KEY_NAME.INVOICE].includes(key)
                    return {
                      id: docName,
                      text: patt[key],
                      debit_account_disabled: debit_account_disabled,
                      credit_account_disabled: credit_account_disabled,
                      debit_account: debit_account_disabled ? null : this.accountSetting.payment_entry.journal[key].debit_account,
                      credit_account: credit_account_disabled ? null : this.accountSetting.payment_entry.journal[key].credit_account,
                    }
                  })
                  .filter((item) => item.id != 'payslip')
                  .map((item) => {
                    const patt = {
                      invoice: KEY_NAME.INVOICE,
                      purchase: KEY_NAME.PURCHASE,
                      expense: KEY_NAME.EXPENSE,
                    }
                    return {
                      ...item,
                      hide: !keyNames.includes(patt[item.id]),
                    }
                  })
              } else {
                return cur.items
              }
            })(),
            links: cur.links.filter((link) => keyNames.includes(link.ref)),
          })
          return acc
        }, [])
    },
  },

  methods: {
    handleClickLink(link) {
      const element = document.getElementById(link.ref)
      if (element) {
        const header = document.querySelector('#header')
        const headerHeight = header.getBoundingClientRect().height
        const contentHeader = document.querySelector('#content .header')
        const contentHeaderHeight = contentHeader.getBoundingClientRect().height
        const offset = contentHeaderHeight + headerHeight
        const elementPosition = element.getBoundingClientRect().top + window.scrollY
        window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' })
      }
    },
    handleItemsChange(keyName, items) {
      this.accountMapping[keyName].items = cloneDeep(items)
    },
    handleToggleDocumentType(docType) {
      this.isRender = false
      this.selectedDocumentTypes = [docType]
      this.$nextTick(() => {
        this.isRender = true
      })
    },
  },

  watch: {
    accountMapping: {
      handler: function () {
        this.$emit('onChange', this.accountMapping)
      },
      deep: true,
    },
  },

  created() {
    const mapGernalDocumentType = (type) => {
      return {
        id: type.name,
        text: getMasterDataText(type.name, this.$t),
        debit_account: type.journal.debit_account,
        credit_account: type.journal.credit_account,
      }
    }

    this.accountMapping[KEY_NAME.POS].items = this.branches.map((branch) => {
      return {
        id: branch.branchId,
        text: branch.name,
        debit_account: branch.journal.debit_account,
        credit_account: branch.journal.credit_account,
      }
    })

    this.accountMapping[KEY_NAME.INVOICE].items = this.saleSetting.types.map(mapGernalDocumentType)
    this.accountMapping[KEY_NAME.PURCHASE].items = this.purchaseSetting.types.map(mapGernalDocumentType)
    this.accountMapping[KEY_NAME.EXPENSE].items = this.expenseSetting.types.map(mapGernalDocumentType)
    this.accountMapping[KEY_NAME.PAYMENT_ENTRY].items = Object.keys(this.accountSetting.payment_entry.journal).map((key) => {
      const docName = key
      const patt = {
        invoice: this.$t('documents.in'),
        purchase: this.$t('documents.po'),
        expense: this.$t('documents.ex'),
        payslip: this.$t('documents.prl'),
      }
      const debit_account_disabled = [KEY_NAME.PURCHASE, KEY_NAME.EXPENSE].includes(key)
      const credit_account_disabled = [KEY_NAME.INVOICE].includes(key)
      return {
        id: docName,
        text: patt[key],
        debit_account_disabled: debit_account_disabled,
        credit_account_disabled: credit_account_disabled,
        debit_account: debit_account_disabled ? null : this.accountSetting.payment_entry.journal[key].debit_account,
        credit_account: credit_account_disabled ? null : this.accountSetting.payment_entry.journal[key].credit_account,
      }
    }).filter((item) => item.id != 'payslip')

    this.accountMapping[KEY_NAME.TAX_SALE].items = this.taxes
      .filter((tax) => tax.is_for_sale)
      .filter((tax) => tax.form_type == 'tax')
      .filter((tax) => tax.amount >= 0)
      .map((tax) => {
        return {
          id: tax.tax_id,
          text: `${getMasterDataText(tax.tax_name, this.$t)} ${Math.abs(tax.amount)}%`,
          debit_account: null,
          credit_account: tax.journal.credit_account,
        }
      })
    this.accountMapping[KEY_NAME.TAX_PURCHASE].items = this.taxes
      .filter((tax) => tax.is_for_purchase || tax.is_for_expense)
      .filter((tax) => tax.form_type == 'tax')
      .filter((tax) => tax.amount >= 0)
      .map((tax) => {
        return {
          id: tax.tax_id,
          text: `${getMasterDataText(tax.tax_name, this.$t)} ${Math.abs(tax.amount)}%`,
          debit_account: tax.journal.debit_account,
          credit_account: null,
        }
      })

    this.accountMapping[KEY_NAME.WHT_SALE].items = this.taxes
      .filter((tax) => tax.is_for_sale)
      .filter((tax) => tax.form_type == 'tax')
      .filter((tax) => tax.amount < 0)
      .map((tax) => {
        return {
          id: tax.tax_id,
          text: `${getMasterDataText(tax.tax_name, this.$t)} ${Math.abs(tax.amount)}%`,
          debit_account: tax.journal.debit_account,
          credit_account: null,
        }
      })

    this.accountMapping[KEY_NAME.WHT_PURCHASE].items = this.taxes
      .filter((tax) => tax.is_for_sale)
      .filter((tax) => tax.form_type == 'tax')
      .filter((tax) => tax.amount < 0)
      .map((tax) => {
        return {
          id: tax.tax_id,
          text: `${getMasterDataText(tax.tax_name, this.$t)} ${Math.abs(tax.amount)}%`,
          debit_account: null,
          credit_account: tax.journal.credit_account,
        }
      })

    this.accountMapping[KEY_NAME.SERVICE_CHARGE].items = this.taxes
      .filter((tax) => tax.is_for_sale)
      .filter((tax) => tax.form_type == 'service_charge')
      .map((tax) => {
        return {
          id: tax.tax_id,
          text: `${getMasterDataText(tax.tax_name, this.$t)} ${Math.abs(tax.amount)}%`,
          debit_account: null,
          credit_account: tax.journal.credit_account,
        }
      })

    this.accountMapping[KEY_NAME.FEE].items = this.taxes
      .filter((tax) => tax.is_for_sale)
      .filter((tax) => tax.form_type == 'fee')
      .map((tax) => {
        return {
          id: tax.tax_id,
          text: `${getMasterDataText(tax.tax_name, this.$t)} ${Math.abs(tax.amount)}%`,
          debit_account: tax.journal.debit_account,
          credit_account: tax.journal.credit_account,
        }
      })

    this.accountMapping[KEY_NAME.COST_OF_SALE].items = this.categories
      .map((category) => {
        return {
          id: category.category_id,
          text: category.category_name,
          debit_account: category.journal.sale.debit_account,
          credit_account: category.journal.sale.credit_account,
        }
      })

    this.loading = false
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/FormAutomatedAccountsMapping.vue